export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6558.a2763285.jpg";